<script>
    import CardImage from './CardImage.svelte';
    import Dashboard from './Dashboard.svelte';
    import StandardBoard from './newcards/board/StandardBoard.svelte';
    import BorgQueenBoard from './newcards/board/unique/BorgQueenBoard.svelte';
    import KhanBoard from './newcards/board/unique/KhanBoard.svelte';
    import QBoard from './newcards/board/unique/QBoard.svelte';
    import TreacheryBoard from './newcards/board/unique/TreacheryBoard.svelte';
    import { state, ui, res, prefs, live } from './stores.js';
    import { tick } from 'svelte/internal'

    let previewSide = 'right';
    let previewCard = null;
    let preview;
    let dashboard;
    export let force = false;
    export let useImages = -1;

    $: checkHover($live, $prefs, $ui);
    //$: console.log($ui.dashboardSelected, $live.previewDashboard)

    $: if($live.shouldHideHover && $live.shouldHideHover.x && $live.shouldHideHover.y){
        //console.log('should?')
        tick().then(() => {
            if(!$live.shouldHideHover) return;
            let element = document.elementFromPoint($live.shouldHideHover.x, $live.shouldHideHover.y);
            if(!preview || (element != preview && !preview.contains(element))){
                $live.hoveringCard = null;
                $live.hoveringFacedown = false;
                $live.previewCard = null;
                //context.cardActions = null;
            }
            $live.shouldHideHover = false;
        });
    }

    $: if($live.shouldHideDashboard && $live.shouldHideDashboard.x && $live.shouldHideDashboard.y){
        //console.log('should dash?')
        tick().then(() => {
            if(!$live.shouldHideDashboard) return;
            let element = document.elementFromPoint($live.shouldHideDashboard.x, $live.shouldHideDashboard.y);
            if(!preview || (element != preview && !preview.contains(element))){
                $live.previewDashboard = null;
                //if(dashboard) dashboard.$destroy();
            }
            $live.shouldHideDashboard = false;
        });
    }

    $: if(dashboard && !$live.previewDashboard && !$ui.dashboardSelected){
        dashboard.$destroy();
    }

    function checkHover(l, prefs){
        if($ui.selection){
            if($live.previewCard != $ui.selection) $live.previewCard = $ui.selection;
        }else if($live.hoveringCard){
            if($live.hoveringCard != $live.previewCard) $live.previewCard = $live.hoveringCard;
        }
        if(prefs.previewScale && (($ui.selection && !$ui.facedown && prefs.showPreview))){
            if($ui.selection != previewCard) previewCard = $ui.selection;
        }else if(prefs.showHover && $live.hoveringCard && !$live.hoveringFacedown){
            if($live.hoveringCard != previewCard) previewCard = $live.hoveringCard;
        }else{
            previewCard = null;
        }
        //$ui.previewCard = previewCard;
    }

    function otherSide(e){
        if(previewSide == 'right') previewSide = 'left'; else previewSide = 'right';
    }

    function closeDashboard(){
        $live.previewDashboard = false;
        $ui.dashboardSelected = false;
    }

    function getDivisor(type){
        if(type == 'track' && previewSide == 'right') return 0.47;
        if(type == 'mission' && previewSide == 'left') return 0.53;
        return 0;
    }
</script>

{#if previewCard && (!previewCard.dashMission || force) && (typeof previewCard.uniqueID == 'number' || !previewCard.uniqueID)}
    <div bind:this={preview} class="preview" style="{previewSide}: 0; width: {57.3 * $prefs.previewScale}mm; height: {80 * $prefs.previewScale}mm; " >
        <div class="preview_card" style={`--width: ${57.3 * $prefs.previewScale}mm; --height: ${80 * $prefs.previewScale}mm; width: ${57.3 * $prefs.previewScale}mm; height: ${80 * $prefs.previewScale}mm;`} on:click={otherSide} on:mouseover={otherSide} on:mousemove={otherSide}>
            <CardImage isPreview width={57.3 * $prefs.previewScale} height={80 * $prefs.previewScale} units="mm" {useImages} selectable={false} c={previewCard} />
        </div> <!-- translate={previewSide == 'right' ? selectedPreview.translateRight : '0, 0'} -->
        {#if $ui.multiSelection && $ui.multiSelection.length > 0}
            <div style="width:100%; display: flex; flex-wrap: nowrap; justify-content: space-between;">
                <button style={$ui.selection != $ui.multiSelection[0] ? '' : 'visibility: hidden;'} on:click={e => {let i = $ui.multiSelection.indexOf($ui.selection); if(i != -1) $ui.selection = $ui.multiSelection[i - 1];}}>←</button>
                <button style={$ui.selection != $ui.multiSelection[$ui.multiSelection.length - 1] ? '' : 'visibility: hidden;'} on:click={e => {let i = $ui.multiSelection.indexOf($ui.selection); if(i != -1) $ui.selection = $ui.multiSelection[i + 1];}}>→</button>
            </div>
        {/if}
    </div>
{:else if $live.previewDashboard || $ui.dashboardSelected}
    {#if $prefs.oldCards}
        <div bind:this={preview} class="preview {$live.dashboardArea}_preview" style="{previewSide}: -{57.3 * $prefs.previewScale * 2 * getDivisor($live.dashboardArea)}mm; width: {57.3 * $prefs.previewScale * 2}mm; height: {76.16 * $prefs.previewScale}mm; --width: {57.3 * $prefs.previewScale * 2}mm; --height: {76.16 * $prefs.previewScale}mm; opacity: 0.9;" on:click={otherSide} on:mouseover={otherSide} on:mousemove={otherSide}>
        
            <Dashboard bind:this={dashboard} p={$live.previewDashboard || $ui.dashboardSelected} width={`${57.3 * $prefs.previewScale * 2}mm`} height={`${76.16 * $prefs.previewScale}mm`} preview={$live.dashboardArea} />
            
        </div>
    {:else if ($live.previewDashboard || $ui.dashboardSelected).captain == 'Borg Queen'}
        <div bind:this={preview} class="preview" style="pointer-events: none; {previewSide}: 0; --height: 50vmin; --width: calc(50vmin / 1654 * 2126); opacity: 0.9;">
            <div class="borg_preview" style="pointer-events: auto;" on:click={closeDashboard} on:mouseover={otherSide} on:mousemove={otherSide}>
                <BorgQueenBoard isPreview={true} p={$live.previewDashboard || $ui.dashboardSelected} board={($live.previewDashboard || $ui.dashboardSelected).dashboard} />
            </div>
        </div>
    {:else}
        <div bind:this={preview} class="preview" style="pointer-events: none; {previewSide}: 0; --height: {$live.dashboardArea == 'mission' ? 50 : 40}vh; --width: calc({$live.dashboardArea == 'mission' ? 50 : 40}vh / 1654 * 2126); opacity: 0.9;">
            <div class="{$live.dashboardArea}_preview" style="pointer-events: auto;" on:click={closeDashboard} on:mouseover={otherSide} on:mousemove={otherSide}>
                {#if ($live.previewDashboard || $ui.dashboardSelected).captain == 'Khan'}
                    <KhanBoard isPreview={true} p={$live.previewDashboard || $ui.dashboardSelected} board={($live.previewDashboard || $ui.dashboardSelected).dashboard} />
                
                {:else if ($live.previewDashboard || $ui.dashboardSelected).captain == 'Q'}
                    <QBoard isPreview={true} p={$live.previewDashboard || $ui.dashboardSelected} board={($live.previewDashboard || $ui.dashboardSelected).dashboard} />
                {:else}
                    <StandardBoard isPreview={true} p={$live.previewDashboard || $ui.dashboardSelected} board={($live.previewDashboard || $ui.dashboardSelected).dashboard} side={($live.previewDashboard || $ui.dashboardSelected).dashSide} />
                {/if}
            </div>
            {#if $live.dashboardArea == 'track' && $res.modules.includes('Treachery')}
                <div class="treachery_preview" style="pointer-events: auto;">
                    <TreacheryBoard isPreview={true} p={$live.previewDashboard || $ui.dashboardSelected} />
                </div>
            {/if}
        </div>
        
    {/if}
{/if}

<style>
    .preview {
        position: fixed;
        z-index: 999;
        width: fit-content;
        top: 0;
        right: 0;
        display: flex;
        flex-direction: column;
    }
    
    .preview_card {
        opacity: 0.9;
        /*max-height: 80vmin;*/
        width: 100%;
        height: 100%;
        
    }

    .track_preview {
        clip-path: polygon(0% 38%, 100% 38%, 100% 100%, 0% 100%);
        transform: translateY(-38%);
    }

    .mission_preview {
        clip-path: polygon(0% 0%, 100% 0%, 100% 38%, 0% 38%);
    }

    .treachery_preview {
        clip-path: polygon(0 63%, 100% 63%, 100% 100%, 0% 100%);
        transform: translateY(-132%);
    }

    .borg_preview {
        max-height: 50vh;
        max-width: 50vw;
    }
</style>